import React, { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import EpisodeList from "./pages/EpisodeList";
import EpisodePlayer from "./pages/EpisodePlayer";
import KeepersPage from "./pages/KeepersPage";
import episodes from "./data/episodes";
import "./App.css";

// Wraps the episode list + player so we can handle auto-play via
// router location state (used when navigating from a Keeper bio page).
function EpisodeListView() {
  const location = useLocation();
  const autoPlayId = location.state?.playEpisodeId ?? null;

  const [selectedEpisode, setSelectedEpisode] = useState(() =>
    autoPlayId ? episodes.find((ep) => ep.id === autoPlayId) ?? null : null
  );

  if (selectedEpisode) {
    return (
      <EpisodePlayer
        episode={selectedEpisode}
        onBack={() => setSelectedEpisode(null)}
      />
    );
  }
  return <EpisodeList onSelect={setSelectedEpisode} />;
}

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EpisodeListView />} />
          <Route path="/keepers" element={<KeepersPage />} />
          <Route path="/keepers/:keeperId" element={<KeepersPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
